import {Question, Answer} from 'organization/Obie/ObieServiceProvider'

export const TYPE_LONG_FORM = 1
export const TYPE_MULTIPLE_CHOICE = 2
export const TYPE_PATH_PARENT = 3
export const TYPE_PATH_QUESTION = 4

export function nextQuestion(
  currentQuestion: Question,
  currentAnswer: Answer | undefined,
  questions: Question[],
) {
  if (
    currentQuestion.type === TYPE_LONG_FORM ||
    currentQuestion.type === TYPE_MULTIPLE_CHOICE
  ) {
    return nextParentQuestion(currentQuestion, questions)
  }

  if (currentQuestion.type === TYPE_PATH_PARENT && currentAnswer) {
    const selectedOption = currentQuestion.options.find(
      (opt) => opt.value === currentAnswer.answer,
    )

    if (!selectedOption) {
      return null
    }

    return selectedOption.path[0]
  }

  if (currentQuestion.type === TYPE_PATH_PARENT && !currentAnswer) {
    if (!currentQuestion.required) {
      return nextParentQuestion(currentQuestion, questions)
    }
  }

  if (currentQuestion.type === TYPE_PATH_QUESTION) {
    const next = nextChildQuestion(currentQuestion, questions)
    if (next) {
      return next
    }
    const parentQuestion = questions.find(
      (q) => q.id === currentQuestion.parent_question_id,
    )
    if (!parentQuestion) {
      return null // Bug
    }

    return nextParentQuestion(parentQuestion, questions)
  }

  return null
}

function nextParentQuestion(currentQuestion: Question, questions: Question[]) {
  const index = questions.indexOf(currentQuestion)
  if (index < 0) return null
  const nextIndex = index + 1
  if (nextIndex >= questions.length) {
    return null
  }
  return questions[nextIndex]
}

function nextChildQuestion(currentQuestion: Question, questions: Question[]) {
  const parentQuestion = questions.find(
    (q) => q.id === currentQuestion.parent_question_id,
  )
  if (!parentQuestion) {
    return null // Bug
  }
  const parentSelectOption = parentQuestion.options.find((opt) =>
    opt.path.find((p) => p.id === currentQuestion.id),
  )
  if (!parentSelectOption) {
    return null // bug
  }

  const index = parentSelectOption.path.indexOf(currentQuestion)

  if (index < 0) {
    return null //bug
  }

  const nextIndex = index + 1
  if (nextIndex >= parentSelectOption.path.length) {
    return null
  }
  return parentSelectOption.path[nextIndex]
}

export function previousQuestion(
  currentQuestion: Question,
  questions: Question[],
) {
  if (
    currentQuestion.type === TYPE_LONG_FORM ||
    currentQuestion.type === TYPE_MULTIPLE_CHOICE
  ) {
    return previousParentQuestion(currentQuestion, questions)
  }

  if (currentQuestion.type === TYPE_PATH_PARENT) {
    return previousParentQuestion(currentQuestion, questions)
  }

  if (currentQuestion.type === TYPE_PATH_QUESTION) {
    const previous = previousChildQuestion(currentQuestion, questions)
    if (previous) {
      return previous
    }
    const parentQuestion = questions.find(
      (q) => q.id === currentQuestion.parent_question_id,
    )
    if (!parentQuestion) {
      return null // Bug
    }
    return parentQuestion
  }
}

function previousParentQuestion(
  currentQuestion: Question,
  questions: Question[],
) {
  const index = questions.indexOf(currentQuestion)
  if (index < 0) return null
  const nextIndex = index - 1
  if (nextIndex < 0) {
    return null
  }
  return questions[nextIndex]
}

function previousChildQuestion(
  currentQuestion: Question,
  questions: Question[],
) {
  const parentQuestion = questions.find(
    (q) => q.id === currentQuestion.parent_question_id,
  )
  if (!parentQuestion) {
    return null // Bug
  }
  const parentSelectOption = parentQuestion.options.find((opt) =>
    opt.path.find((p) => p.id === currentQuestion.id),
  )
  if (!parentSelectOption) {
    return null // bug
  }

  const index = parentSelectOption.path.indexOf(currentQuestion)

  if (index < 0) {
    return null //bug
  }

  const previousIndex = index - 1
  if (previousIndex < 0) {
    return null
  }
  return parentSelectOption.path[previousIndex]
}
